import { gregorianToJalali, jalaliMonths, jalaliToDate } from './jalali';

export function giveDayInfo(val: string | undefined) {
  if (!val) return undefined;
  const d = new Date(val);
  const greg = gregorianToJalali(d.getFullYear(), d.getMonth() + 1, d.getDate());
  return { JYear: greg.year, JMonth: greg.month, JDay: greg.dat, dayOfWeek: d.getDay() };
}

export function formatJalaliDateLabel(date = new Date()): string {
  const j = gregorianToJalali(date.getFullYear(), date.getMonth() + 1, date.getDate());
  return `${j.dat} ${jalaliMonths[j.month] ?? ''} ${j.year}`;
}

export function formatJalaliIso(date = new Date()): string {
  const j = gregorianToJalali(date.getFullYear(), date.getMonth() + 1, date.getDate());
  const m = String(j.month).padStart(2, '0');
  const d = String(j.dat).padStart(2, '0');
  return `${j.year}/${m}/${d}`;
}

export function daysUntil(dateStr: string, from = new Date()): number {
  return Math.floor((new Date(dateStr).getTime() - from.getTime()) / 86400000);
}

export function secToHm(sec: number): string {
  const h = Math.floor(sec / 3600);
  const m = Math.floor((sec % 3600) / 60);
  if (h > 0) return `${h}:${String(m).padStart(2, '0')}`;
  return `${m} min`;
}

export function workoutComplianceColor(item: {
  total_time?: number | null;
  total_time_planned?: number | string | null;
  tss_actual?: number | null;
  tss_planned?: number | string | null;
}): string {
  const inRange = (a: number, p: number) => a >= p * 0.7 && a < p * 1.3;
  const partial = (a: number, p: number) => a >= p * 0.35 && a < p * 1.65;
  const at = item.total_time != null ? Number(item.total_time) : null;
  const pt = item.total_time_planned != null ? Number(item.total_time_planned) : null;
  const atss = item.tss_actual != null ? Number(item.tss_actual) : null;
  const ptss = item.tss_planned != null ? Number(item.tss_planned) : null;
  if (at && pt) {
    if (inRange(at, pt)) return '#16a34a';
    if (partial(at, pt)) return '#f97316';
    return '#ef4444';
  }
  if (atss && ptss) {
    if (inRange(atss, ptss)) return '#16a34a';
    if (partial(atss, ptss)) return '#f97316';
    return '#ef4444';
  }
  return '#9ca3af';
}
